// extracted by mini-css-extract-plugin
export default {"gameTitle":"Title__gameTitle--fow"};